<template>
    <section class="text-block text-block--right-text">
        <b-container fluid="xl">        
            <b-row>
                <b-col cols="12" md="6"                     
                    class="text-block__img-wrap"
                    v-inview="vInViewAnimation1"       
                    :class="{'order-2': this.$route.params.product_slug == 'meggy_ale'}"             
                >
                    <div class="text-block__img" v-if="imagesrc">                        
                        <img 
                            :src="imagesrc" 
                            class="img-fluid"
                        />
                    </div>                    
                </b-col>
                <b-col cols="12" md="6" class="text-block__content-wrap"                                 
                    v-inview="vInViewAnimation2"       
                    :class="{'order-1': this.$route.params.product_slug == 'meggy_ale'}"
                >                
                    <div class="text-block__content" >
                        <div class="text" v-html="text"></div>                        
                    </div>                            
                </b-col>
            </b-row>            
        </b-container>
    </section>
</template>

<script>
export default {
    props:['text', 'imagesrc'],
    computed: {
        vInViewAnimation1() {
            return this.$route.params.product_slug != 'meggy_ale' ? 'fade-from-left' : 'fade-from-right'
        },
        vInViewAnimation2() {
            return this.$route.params.product_slug != 'meggy_ale' ? 'fade-from-right' : 'fade-from-left'
        }
    },
}
</script>